import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { User } from '../models/User';
import { CompanyUserModel } from 'app/shared/models/company-user.model';

@Injectable()
export class SharedService {
    private user = new BehaviorSubject(new User());
    private companyUserList = new BehaviorSubject<CompanyUserModel[]>([]);

    currentUser = this.user.asObservable();
    currentCompanyUser = this.companyUserList.asObservable();

    constructor() {
        console.log(this.currentUser);

    }

    changeCurrentUser(user: User) {
        this.user.next(user);
    }
    changeCurrentCompanyUser(companyUserList: CompanyUserModel[]) {
        this.companyUserList.next(companyUserList);
    }
}
